module.exports = __webpack_public_path__ + "img/shulanyiyuanLogo.01b8c6c4.png";